/**
 * Demo account utilities — safe for both server and client components.
 */

const DEMO_EMAIL = "demo@sigmavue.com";

/**
 * Check if an email is the demo account.
 * Pure function — no React hooks, no "use client" directive.
 */
export function isDemoEmail(email: string | null | undefined): boolean {
  return email?.toLowerCase() === DEMO_EMAIL;
}
